import { createSelector } from '@ngrx/store';
import { AppState } from '../index';
import { FlowsState } from './flows.reducer';

export const $flowsState = (state: AppState): FlowsState => state.flows;

export const $flows = createSelector($flowsState, ({ flows }) => flows);

export const $flowsLoading = createSelector(
    $flowsState,
    ({ flowsLoading }) => flowsLoading,
);

export const $flowsError = createSelector(
    $flowsState,
    ({ flowsError }) => flowsError,
);

export const $deviceCode = createSelector(
    $flowsState,
    ({ deviceCode }) => deviceCode,
);

export const $deviceCodeLoading = createSelector(
    $flowsState,
    ({ deviceCodeLoading }) => deviceCodeLoading,
);

export const $deviceCodeStatus = createSelector(
    $flowsState,
    ({ deviceCodeStatus }) => deviceCodeStatus,
);
